import { ActionIcon, Group, Text } from '@mantine/core'
import { DeleteOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { getOrderFileUrl } from '../order-files.utils'

type OrderFileProps = {
  index: number;
  filename: string;
  s3Url: string|null;
  data: File|null;
  isLoading: boolean;
  hasRemoveButton: boolean;
  onRemoveFile: (filename: string) => void;
}

export function OrderFileView({
  filename,
  index,
  s3Url,
  data,
  isLoading,
  hasRemoveButton,
  onRemoveFile,
}: OrderFileProps) {
  return (
    <Group mt={5} align='center'>
      <Group>
        <Text size='sm' mr={5} weight={700}>
          {index + 1}
        </Text>
        {!s3Url && !data && (
          <Text
            title={filename}
            size='sm'
            //maw={290}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {filename}
          </Text>
        )}
        {(s3Url || data) && (
          <Link
            to={{ pathname: getOrderFileUrl(s3Url, data) }}
            target='_blank'
          >
            <Text
              title={filename}
              size='sm'
              //maw={290}
              style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {filename}
            </Text>
          </Link>
        )}
      </Group>
      {hasRemoveButton && (
        <ActionIcon
          ml={5}
          size={'md'}
          radius={'sm'}
          onClick={() => onRemoveFile(filename)}
          loading={isLoading}
        >
          <DeleteOutlined size={16}/>
        </ActionIcon>
      )}
    </Group>
  )
}
